import { authInstance } from './axios'
let url = process.env.REACT_APP_API_URL

export const economicActivitiesService = {
  getEconomicActivities: async (data) => {
    const response = await authInstance
      .get(`${url}/economicActivities/listActive`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },
}
